import {
    WorkbenchPlugin,
    WorkbenchPluginId, WorkbenchViewConfig, WorkbenchViewKind
} from '../../shared/types';
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {ShowExpeditionViewComponent} from "./views/show-expedition-view.component";
import {faCompass} from "@fortawesome/pro-solid-svg-icons";
import {ExpeditionListComponent} from "./views/expedition-list.component";
import {WorkbenchCommandRegistry} from "../../shared/services/workbench-command-registry.service";
import {WorkbenchLayoutManager} from "../../shared/services/workbench-layout-manager.service";
import {ExpeditionAutomationComponent} from './views/expedition-automation.component';
import {ExpeditionTimelineComponent} from './views/expedition-timeline.component';

// @WorkbenchPlugin
@Injectable()
export class ExpeditionPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'expedition';
    views: WorkbenchViewKind[];

    static readonly BrowserSessionViewerViewId = 'expedition.view.browsersession-viewer';
    static readonly ExpeditionListViewId = 'expedition.view.expedition-list';
    static readonly ExpeditionAutomationViewId = 'expedition.view.expedition-automation';
    static readonly ExpeditionTimelineViewId = 'expedition.view.expedition-timeline';

    private viewContainerId = 'expedition.viewcontainer';

    constructor(private commandRegistry: WorkbenchCommandRegistry,
                readonly layoutManager: WorkbenchLayoutManager) {
        super(layoutManager);
        this.views = [
            {
                id: ExpeditionPlugin.BrowserSessionViewerViewId,
                component: ShowExpeditionViewComponent,
                name: 'State Viewer', // TODO
                expandedByDefault: true,
                defaultViewContainer: this.viewContainerId,
            },
            {
                id: ExpeditionPlugin.ExpeditionListViewId,
                component: ExpeditionListComponent,
                name: 'Browser Sessions',
                expandedByDefault: false,
                defaultViewContainer: this.viewContainerId,
            },
            {
                id: ExpeditionPlugin.ExpeditionAutomationViewId,
                component: ExpeditionAutomationComponent,
                name: 'Automation',
                expandedByDefault: false,
                defaultViewContainer: this.viewContainerId,
            },
            {
                id: ExpeditionPlugin.ExpeditionTimelineViewId,
                component: ExpeditionTimelineComponent,
                name: 'Timeline',
                expandedByDefault: false,
                defaultViewContainer: this.viewContainerId,
            },

        ];
    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: this.viewContainerId,
            name: 'Browser Session Analysis',
            icon: {
                type: 'faIcon',
                instance: faCompass,
            },
            allowedPanels: ['left-top', 'left-bottom'],
            defaultPanel: 'left-top',
            displayMode: 'stacked',
            toolbarCommandId: 'expedition:toggleViewContainer'
        });

        this.commandRegistry.registerCommand(
            'expedition:toggleViewContainer',
            {
                name: 'Browser Session Analysis',
                icon: {
                    type: 'faIcon',
                    instance: faCompass,
                },
                description: 'Show Browser Session View',
                statusBindings: {
                    'active': {
                        'type': 'store',
                        'storeKey': `viewcontainers.${this.viewContainerId}.status.visible`,
                    }
                }
            },
            () => {
                this.layoutManager.toggleViewContainer(this.viewContainerId, true);
            }
        )

        return of(undefined);
    }
}

